export const isValidHex = (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);

const getChunksFromString = (st, chunkSize) =>
  st.match(new RegExp(`.{${chunkSize}}`, 'g'));

const convertHexUnitTo256 = (hexStr) =>
  parseInt(hexStr.repeat(2 / hexStr.length), 16);

export const getAlphafloat = (a, alpha) => {
  if (typeof a !== 'undefined') {
    return a / 255;
  }
  if (typeof alpha !== 'number' || alpha < 0 || alpha > 1) {
    return 1;
  }
  return alpha;
};

export const hexToRgba = (hex, alpha) => {
  if (!isValidHex(hex)) {
    throw new Error('Invalid HEX');
  }
  const chunkSize = Math.floor((hex.length - 1) / 3);
  const hexArr = getChunksFromString(hex.slice(1), chunkSize);
  const [r, g, b, a] = hexArr.map(convertHexUnitTo256);
  return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`;
};

export const mapColor = (str, s, l) => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash < 5) - hash);
  }
  const h = hash % 360;
  return `hsl(${h}, ${s}%, ${l}%)`;
};

export const setFontSize = ({ theme, size, fontSize }) => {
  if (size === 'small' && !fontSize) return theme.typography.pxToRem(13);
  if (fontSize) return theme.typography.pxToRem(fontSize);
  return 'default';
};

export const enableWhiteLabelStyling = ({
  ignoreWhiteLabel,
  whiteLabelStyle,
  defaultStyle,
}) => {
  if (ignoreWhiteLabel) return defaultStyle;
  return whiteLabelStyle || defaultStyle;
};

export const lightenColor = (hex, percent = 30) => {
  const color = hex.replace('#', '');

  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  const newR = Math.min(255, Math.round(r + (255 - r) * (percent / 100)));
  const newG = Math.min(255, Math.round(g + (255 - g) * (percent / 100)));
  const newB = Math.min(255, Math.round(b + (255 - b) * (percent / 100)));

  const toHex = (n) => {
    const hexStr = n.toString(16);
    return hexStr.length === 1 ? `0${hexStr}` : hexStr;
  };

  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
};